import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  MenuItem,
  Paper,
  Snackbar,
  TextField,
  Alert,
} from "@mui/material";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";
import { API_ENDPOINT } from "../../utils/constants";
import { getHeader } from "../../utils/util";
import { useParams } from "react-router-dom";

/** centralise initial state so you can also reuse it for a form-reset */
const initialForm = {
  email: "",
  password: "",
  profileName: "",
};

const AddUser = () => {
  const { id } = useParams();
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [snack, setSnack] = useState({
    open: false,
    msg: "",
    severity: "success",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // basic front-end validation (everything except wabaToken required)
    for (const key of Object.keys(initialForm)) {
      if (key !== "wabaToken" && form[key].trim() === "") {
        setSnack({
          open: true,
          msg: `Please fill ${key}`,
          severity: "warning",
        });
        return;
      }
    }

    try {
      setSubmitting(true);
      await axios.post(
        `${API_ENDPOINT}/root/add-user?customerId=${id}`,
        form,
        getHeader()
      ); // 🔗 adjust endpoint if needed
      setSnack({
        open: true,
        msg: "Account added successfully!",
        severity: "success",
      });
      setForm(initialForm);
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.message ||
        "Something went wrong while saving.";
      setSnack({ open: true, msg, severity: "error" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container sx={{ my: 3 }}>
      <BackBtn />

      <Container maxWidth="md">
        <PageTitle sx={{ mt: 2 }}>Add User</PageTitle>

        <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email"
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  fullWidth
                  required
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Password"
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  fullWidth
                  required
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Profile Name"
                  name="profileName"
                  value={form.profileName}
                  onChange={handleChange}
                  fullWidth
                  required
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sx={{ textAlign: "right" }}>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={submitting}
                  startIcon={submitting && <CircularProgress size={18} />}
                >
                  {submitting ? "Saving…" : "Save Account"}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>

      <Snackbar
        open={snack.open}
        autoHideDuration={4000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnack((s) => ({ ...s, open: false }))}
          severity={snack.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default AddUser;
